/****************************************************
 * Module Name:  rapnetloginsMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import renderCellExpand from "../common/dataGridCellExpand";
import RapnetLoginsProxy from "../../utility/proxy/manager/rapnetLoginsProxy";
import AddRapnetloginsModal from "./addRapnetloginsModal";
import Utility from "../../utility/utility";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class RapnetLoginMaster extends Component {
  constructor(props) {
    super(props)

    this.state = {
      rapnetLogins: [],
      sourceData: {},
      editOperation: false,
      errorSnackbar: false,
      errorMessage: "",
      loadingButton: false,
      showAddRapnetLoginsModal: false,
      showRapentLoginsLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.MASTER_RAPNET_LOGINS
      ),
      showSuccessSnackbar: false,
      successMessage: "",
    }
    this.fetchRapnetLoginsData()
  }

  componentDidMount() {
    PageTitle("MASTER_RAPNET_LOGINS");
  }

  fetchRapnetLoginsData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showRapentLoginsLoadSpinner: true })
    RapnetLoginsProxy.GetAllRapnetLogins((res) => {
      if (res && res.length >= 0) {
        this.setState({ rapnetLogins: res, showRapentLoginsLoadSpinner: false })
      } else {
        this.setState({
          errorSnackbar: true,
          errorMessage: Constants.APiFailErrorMessage,
          showRapentLoginsLoadSpinner: false
        })
      }
    })

  }

  columns = [
    {
      field: "rapnetid",
      headerName: "RAPNET ID",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
    },
    {
      field: "clientid",
      headerName: "CLIENT ID",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      renderCell: renderCellExpand,
    },
    {
      field: "clientsecret",
      headerName: "CLIENT SECRET",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "membercomment",
      headerName: "MEMBER COMMENT",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "disable",
      headerName: "DISABLE",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      renderCell: (params) => {
        return params.value === false ? (
          <Tooltip title="Enable">
            <Box>
              <PersonIcon color="success" />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip title="Disable">
            <Box>
              <PersonOffIcon color="error" />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddRapnetLoginsModal: true,
                editOperation: true,
                sourceData: params.row,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ]

  addRapentLogins = (loginData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Update existing Rapnet Logins, and once user is updated on call refresh the list of current users
      RapnetLoginsProxy.UpdateRapnetLogins(loginData, (response) => {
        if (response) {
          this.setState({
            showAddRapnetLoginsModal: false,
            showSuccessSnackbar: true,
            successMessage: "Rapnet login credential updated successfully",
            loadingButton: false
          });
          this.fetchRapnetLoginsData(true);
        } else {
          this.setState({
            errorSnackbar: true,
            errorMessage: Constants.APiFailErrorMessage,
            loadingButton: false
          });
        }
      });
    } else {
      //Creating new Rapnet Logins, and once user is created on call refresh the list of current users
      RapnetLoginsProxy.AddRapnetLogins(loginData, (response) => {
        if (response) {
          this.setState({
            showAddRapnetLoginsModal: false,
            showSuccessSnackbar: true,
            successMessage: "Rapnet login credential added successfully",
            loadingButton: false
          });
          this.fetchRapnetLoginsData(true);
        } else {
          this.setState({
            errorSnackbar: true,
            errorMessage: Constants.APiFailErrorMessage,
            loadingButton: false
          });
        }
      });
    }
  }

  handleValidation = (rapnetLoginsData) => {
    //TODO do validation if needed here
    return true;
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: "block" }} />
          {this.state.showClarityLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchRapnetLoginsData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Rapnet Logins">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddRapnetLoginsModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Rapnet Logins
              </Button>
            </Tooltip>
          ) : null}
          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      )
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission);
    if (!allowed) {
      return <NoPermission />
    }

    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");
    const rows = this.state.rapnetLogins;

    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title={"Failed"}
        />

        {this.state.showSuccessSnackbar ? (
          <CommonSnackbar
            show={true}
            message={this.state.successMessage}
            variant={"success"}
            autoHide={Constants.SnackBarCloseTimer}
            title={"Success"}
            handleClose={() => this.setState({ showSuccessSnackbar: false })}
          />
        ) : null}

        <br />
        {this.state.showAddRapnetLoginsModal ? (
          <AddRapnetloginsModal
            Show={true}
            handleClose={() => this.setState({ showAddRapnetLoginsModal: false })}
            handleSave={this.addRapentLogins}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
            saveButton={true}
          />
        ) : (
          <Box />
        )}
        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              loading={this.state.showClarityLoadSpinner}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{
                toolbar: CustomToolbar,
              }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.rapnetid}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default RapnetLoginMaster;